import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import RegistrationClosed from "./registrationClosed";
import Wrapper from "../wrapper";
import Line from "../../assets/images/Line.svg";
import { subscribeToSiteSettings } from "../../lib/firestoreContent";

function GeneralDetails() {
  const navigate = useNavigate();
  const [loadingSettings, setLoadingSettings] = useState(true);
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);

  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem("formData");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        return {};
      }
    }
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      age: "",
      whatsappNumber: "",
      gender: "",
      dateOfBirth: "",
    };
  });

  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    const unsubscribe = subscribeToSiteSettings((settings) => {
      setIsRegistrationOpen(!!settings?.registrationOpen);
      setLoadingSettings(false);
    });
    return () => unsubscribe && unsubscribe();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setValidationError("");
  };

  const handleNext = (e) => {
    if (e) e.preventDefault();
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.phone) {
      setValidationError("Please fill out all required fields marked with *");
      return;
    }
    localStorage.setItem("formData", JSON.stringify(formData));
    navigate("/course-selection");
  };

  if (loadingSettings) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-slate-500">Checking registration status…</p>
      </div>
    );
  }

  if (!isRegistrationOpen) {
    return <RegistrationClosed />;
  }

  return (
    <div
      style={{
        zIndex: 99,
        fontFamily: "'Clash Display', sans-serif",
      }}
    >
      <Wrapper>
        <h1
          style={{ fontFamily: "'Clash Display', sans-serif", fontWeight: 900 }}
          className="text-center mt-[150px] m-5 text-[30px] md:text-[35px] text-primary font-bolder"
        >
          Let’s get you registered
        </h1>
        <p
          style={{ fontFamily: "'Clash Display', sans-serif", fontWeight: 900 }}
          className="text-center m-5 text-[22px] md:text-[25px] text-[#4B4B4B] font-bolder"
        >
          Enter your details to get going
        </p>
        <nav>
          <ul
            style={{
              fontFamily: "'Clash Display', sans-serif",
              fontWeight: 500,
            }}
            className="flex w-[90%] m-auto justify-between text-[14px]"
          >
            <li>
              <NavLink
                to="/register"
                className={({ isActive }) =>
                  `text-lg ${isActive ? "font-bold text-primary underline" : ""}`
                }
              >
                General Details
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/course-selection"
                className={({ isActive }) =>
                  `text-lg ${isActive ? "font-bold text-primary underline" : ""}`
                }
              >
                Course Selection
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/submit"
                className={({ isActive }) =>
                  `text-lg ${isActive ? "font-bold text-primary underline" : ""}`
                }
              >
                Submit
              </NavLink>
            </li>
          </ul>
        </nav>
        <img src={Line} alt="" className="w-[90%] m-auto h-[20px]" />

        {validationError && (
          <p role="alert" className="w-[90%] md:w-[70%] m-auto mt-4 rounded-md bg-red-50 p-3 text-sm text-red-600">
            {validationError}
          </p>
        )}

        <form
          className="bg-white w-[90%] md:w-[70%] rounded-md shadow-2xl m-auto p-[30px] mt-[50px] mb-[30px]"
          onSubmit={handleNext}
        >
          <div className="md:flex">
            <div className="w-[90%] m-auto mt-[10px]">
              <label className="font-medium text-[17px]">
                First Name<span className="text-[red] ml-1">*</span>
              </label>
              <br />
              <input
                type="text"
                name="firstName"
                value={formData.firstName || ""}
                onChange={handleChange}
                placeholder="Write your firstname"
                className="border border-black rounded-md mt-[5px] p-[4px] w-[90%]"
                required
              />
            </div>
            <div className="w-[90%] m-auto mt-[10px]">
              <label className="font-medium text-[17px]">
                Last Name<span className="text-[red] ml-1">*</span>
              </label>
              <br />
              <input
                type="text"
                name="lastName"
                value={formData.lastName || ""}
                onChange={handleChange}
                placeholder="Write your lastname"
                className="border border-black rounded-md mt-[5px] p-[4px] w-[90%]"
                required
              />
            </div>
          </div>

          <div className="md:flex">
            <div className="w-[90%] m-auto mt-[10px]">
              <label className="font-medium text-[17px]">
                Email Address<span className="text-[red] ml-1">*</span>
              </label>
              <br />
              <input
                type="email"
                name="email"
                value={formData.email || ""}
                onChange={handleChange}
                placeholder="Write your email address"
                className="border border-black rounded-md mt-[5px] p-[4px] w-[90%]"
                required
              />
            </div>
            <div className="w-[90%] m-auto mt-[10px]">
              <label className="font-medium text-[17px]">
                Phone Number<span className="text-[red] ml-1">*</span>
              </label>
              <br />
              <input
                type="tel"
                name="phone"
                value={formData.phone || ""}
                onChange={handleChange}
                placeholder="start with a country code"
                className="border border-black rounded-md mt-[5px] p-[4px] w-[90%]"
                required
              />
            </div>
          </div>

          <div className="md:flex">
            <div className="w-[90%] m-auto mt-[10px]">
              <label className="font-medium text-[17px]">Age</label>
              <br />
              <input
                type="number"
                name="age"
                value={formData.age || ""}
                onChange={handleChange}
                placeholder="Enter your age"
                className="border border-black rounded-md mt-[5px] p-[4px] w-[90%]"
                min="0"
              />
            </div>
            <div className="w-[90%] m-auto mt-[10px]">
              <label className="font-medium text-[17px]">WhatsApp Number</label>
              <br />
              <input
                type="tel"
                name="whatsappNumber"
                value={formData.whatsappNumber || ""}
                onChange={handleChange}
                placeholder="start with a country code"
                className="border border-black rounded-md mt-[5px] p-[4px] w-[90%]"
              />
            </div>
          </div>

          <div className="md:flex">
            <div className="w-[90%] m-auto mt-[10px]">
              <label className="font-medium text-[17px]">Gender</label>
              <br />
              <select
                name="gender"
                value={formData.gender || ""}
                onChange={handleChange}
                className="border border-black rounded-md mt-[5px] p-[4px] w-[90%]"
              >
                <option value="">Select your gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
            <div className="w-[90%] m-auto mt-[10px]">
              <label className="font-medium text-[17px]">Date of Birth</label>
              <br />
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth || ""}
                onChange={handleChange}
                className="border border-black rounded-md mt-[5px] p-[4px] w-[90%]"
              />
            </div>
          </div>

          <div className="flex justify-end mt-6">
            <button
              type="submit"
              className="p-[10px] rounded-md bg-primary text-white hover:bg-[#1b1449] transition font-medium"
            >
              Save & Continue
            </button>
          </div>
        </form>
      </Wrapper>
    </div>
  );
}

export default GeneralDetails;
